/* global $:true dataLayer:true */
/**
 * Analytics Trigger
 *
 * Send google analytics on element events.
 *
 * @example
 *    <input
 *        type="radio"
 *        data-analytics-trigger
 *        data-analytics-trigger-on="click"
 *        data-analytics-trigger-event-name="checkboxClicked"
 *        data-analytics-trigger-some-value="foo"
 *        data-analytics-trigger-some-other-value="bar"
 *        data-analytics-trigger-yet-another-value="baz">
 *
 *    <input
 *        type="search"
 *        data-analytics-trigger
 *        data-analytics-trigger-on="click"
 *        data-analytics-trigger-extract-value-as="searchTerm"
 *        data-analytics-trigger-event-name="checkboxClicked">
 */

import $ from 'jquery';
import plugin from '@core/plugins/lib';

const ELEMENT_SELECTOR = '[data-analytics-trigger]';
const ZERO = 0;

class AnalyticsTriggerPlugin {

    constructor (element, options) {
        this.element = element;
        this.options = options;
        this.$element = $(element);
        this.watching = null;
        this.$nodeType = this.$element.get(ZERO).nodeType;
        this.isFormField = ['input', 'textarea', 'select', 'button'].includes(this.$nodeType);        

        this.watch();        
    }

    watch () {
        this.watching = this.$element.on(this.options.on, this.trigger.bind(this));        
    }

    unwatch () {
        this.$element.off(this.watching);        
    }

    trigger () {        
        const data = Object
            .keys(this.options)
            .filter((key) => !['on', 'extractValueAs'].includes(key))
            .reduce((result, key) => {
                result[key] = this.options[key];

                return result;
            }, {});

        if (this.isFormField && this.options.extractValueAs) {
            data[this.options.extractValueAs] = this.$element.val();
        }
        if (typeof dataLayer !== 'undefined') { 
            dataLayer.push(data);
        }
    }
}

AnalyticsTriggerPlugin.DEFAULTS = {
    on: "click",
    event: null,
    extractValueAs: null
};

plugin('analyticsTrigger', AnalyticsTriggerPlugin);

$(document).ready(() => {
	$(ELEMENT_SELECTOR)['analyticsTrigger']();
});


// WEBPACK FOOTER //
// ./client/src/core/components/buttons/analytics-trigger.js